import { Trans } from '@lingui/macro'
import { formatNumber, NumberType } from '@x-swap-protocol/conedison/format'
import { ButtonOutlined, SmallButtonPurple } from 'components/Button'
import Column from 'components/Column'
import Row from 'components/Row'
import { MAX_WIDTH_MEDIA_BREAKPOINT } from 'components/Tokens/constants'
import { MouseoverTooltip } from 'components/Tooltip'
import { ITopTrades } from 'graphql/competition/TopTrader'
import { IUserInfo } from 'graphql/competition/UserInfo'
import { IUserTrade } from 'graphql/competition/UserTrades'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { useAtomValue } from 'jotai/utils'
import React, { ReactNode, useCallback, useMemo } from 'react'
import { AlertTriangle, ExternalLink, Info } from 'react-feather'
import { useTwitterIsBound } from 'state/competition/hooks'
import { updateReferralModal } from 'state/competition/reducer'
import { useAppDispatch } from 'state/hooks'
import styled from 'styled-components/macro'
import { CopyHelper } from 'theme'
import { getNowSeconds } from 'utils/getNowSeconds'

import InfoDropdown from './InfoDropdown'
import { sortAscendingAtom, sortMethodAtom, TokenSortMethodCompetition } from './state'
import { HeaderRow, LoadedRow, LoadingRow } from './TokenRow'

const GridContainer = styled.div<{ marginTop?: string }>`
  display: flex;
  flex-direction: column;
  max-width: ${MAX_WIDTH_MEDIA_BREAKPOINT};
  margin-left: auto;
  margin-right: auto;
  margin-top: ${({ marginTop }) => marginTop || ''};
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.backgroundSwap};
  border: 1px solid ${({ theme }) => theme.backgroundSwapOutline};
  box-shadow: ${({ theme }) => theme.backgroundSwapShadow};
`

const InfoBlocksWrapper = styled.div`
  max-width: ${MAX_WIDTH_MEDIA_BREAKPOINT};
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  /* display: flex; */
  gap: 1rem;
  /* flex-wrap: wrap; */
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media only screen and (max-width: 767px) {
    grid-template-columns: 1.5fr 1.5fr;

    /* grid-template-columns: 3fr 1.5fr 1.5fr; */
    /* grid-template-rows: 2; */
  }
`

const TokenDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  width: 100%;
`

const NoTokenDisplay = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 60px;
  color: ${({ theme }) => theme.textTertiary};
  font-size: 16px;
  font-weight: 500;
  align-items: center;
  padding: 0px 28px;
  gap: 8px;
`

const MultiplierTime = styled.div`
  width: fit-content;
  padding: 2px 4px;
  border-radius: 5px;
  font-size: 13px;
  line-height: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.black};
  background-color: ${({ theme }) => theme.gray30};
`

const InfoContainer = styled.div<{
  isFirst?: boolean
  hideOnDesctop?: boolean
  hideOnMobile?: boolean
  width?: string
  minWidth?: string
}>`
  position: relative;
  display: ${({ hideOnDesctop }) => (hideOnDesctop ? 'none' : 'flex')};
  flex-direction: column;
  background: ${({ theme }) => theme.backgroundSwap};
  border: 1px solid ${({ theme }) => theme.backgroundSwapOutline};
  gap: 0.5rem;
  border-radius: 12px;
  padding: 12px;
  width: ${({ width }) => width || '100%'};
  min-width: ${({ minWidth }) => minWidth || '200px'};
  @media only screen and (max-width: 767px) {
    ${({ isFirst }) =>
      isFirst &&
      `
  grid-column-start:1;
  grid-column-end:3;
`}
  }
  @media only screen and (max-width: 440px) {
    grid-column-start: 1;
    grid-column-end: 3;
    display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
  }
`

const Label = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.textTertiary};
`

const Content = styled.div<{ bigContent?: boolean }>`
  font-size: ${({ bigContent }) => (bigContent ? '22px' : '16px')};
  font-weight: ${({ bigContent }) => (bigContent ? '600' : '')};
  line-height: 24px;
`

const InfoIconContainer = styled.div`
  margin-left: 2px;
  display: flex;
  align-items: center;
  cursor: help;
`

const Desc = styled.div`
  position: absolute;
  z-index: 2;
  top: 12px;
  right: 12px;
`

const TotalInfoWrapper = styled.div`
  max-width: ${MAX_WIDTH_MEDIA_BREAKPOINT};
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  display: flex;
  gap: 1rem;

  /* flex-direction: column; */

  /* @media only screen and (max-width: 767px) {
    flex-direction: row;
    gap: 1rem;
  }

  @media only screen and (max-width: 440px) {
    flex-direction: column;
    gap: 1rem;
  } */
`

const TwitterWrapper = styled.div`
  padding: 9px 20px;
  width: auto;
  font-weight: 500;
  font-size: 14px;
  background: ${({ theme }) =>
    theme.darkMode
      ? 'linear-gradient(90deg, #1E28A9 0.78%, #8713D6 100%)'
      : 'linear-gradient(90deg, #534FC7 0%, #AC10AC 100%)'};
  color: ${({ theme }) => theme.white};
  border-radius: 12px;
  border: none;
  outline: none;
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  inline-size: max-content;
`

const UserInfoWrapper = styled.div`
  max-width: ${MAX_WIDTH_MEDIA_BREAKPOINT};
  margin-left: 0;
  margin-right: auto;
  display: flex;
  flex-direction: column;
`

const UserPlace = styled.div`
  font-size: 32px;
  font-weight: 600;
  display: flex;
  align-items: center;
`

const Telegram = styled.a`
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.blue400};
  text-decoration: none;
`

const UserDesc = styled.div`
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.textTertiary};
`

const CopyText = styled(CopyHelper).attrs({
  iconSize: 13,
  iconPosition: 'right',
  isIconVisible: true,
  iconColor: 'white',
})``

const UserInfoContainer = styled(Row)`
  margin-top: 20;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`

interface IInfoBlock {
  firstLabel: string
  firstContent: React.ReactNode
  secondLabel?: string
  secondContent?: React.ReactNode
  description: string
  width?: string
  minWidth?: string
  isFirst?: boolean
  hideOnDesctop?: boolean
  hideOnMobile?: boolean
  bigContent?: boolean
}

const InfoBlock = ({
  firstContent,
  firstLabel,
  secondContent,
  secondLabel,
  description,
  isFirst,
  hideOnDesctop,
  hideOnMobile,
  minWidth,
  width,
  bigContent,
}: IInfoBlock) => {
  return (
    <InfoContainer
      isFirst={isFirst}
      hideOnDesctop={hideOnDesctop}
      hideOnMobile={hideOnMobile}
      width={width}
      minWidth={minWidth}
    >
      <Desc>
        {description && (
          <MouseoverTooltip text={description} placement="right">
            <InfoIconContainer>
              <Info size={14} color="#797D9B" />
            </InfoIconContainer>
          </MouseoverTooltip>
        )}
      </Desc>
      <Column>
        <Label>{firstLabel}:</Label>
        <Content bigContent={bigContent}>{firstContent}</Content>
      </Column>
      {secondLabel && secondContent && (
        <Column>
          <Label>{secondLabel}:</Label>
          <Content bigContent={bigContent}>{secondContent}</Content>
        </Column>
      )}
    </InfoContainer>
  )
}

function NoTokensState({ message }: { message: ReactNode }) {
  return (
    <GridContainer id="competition-token-table" marginTop="4rem">
      <HeaderRow />
      <NoTokenDisplay>{message}</NoTokenDisplay>
    </GridContainer>
  )
}

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer id="competition-token-table" marginTop="4rem">
      <HeaderRow />
      <TokenDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TokenDataContainer>
    </GridContainer>
  )
}

const sortableCategories = {
  [TokenSortMethodCompetition.Score]: 'totalUsdVolume',
  [TokenSortMethodCompetition.TRADES_COUNT]: 'txCount',
  [TokenSortMethodCompetition.Volume]: 'atv',
  [TokenSortMethodCompetition.Score24]: 'score24',
}

const TWITTER_WIDTH = 560
const TWITTER_HEIGHT = 480

interface Props {
  userTrades: IUserTrade
  userInfo: IUserInfo
  topTrades: ITopTrades
  account?: string
  tokensData: any
}
export default function TokenTable({ userTrades, userInfo, topTrades, account, tokensData }: Props) {
  const sortMethod = useAtomValue(sortMethodAtom)
  const sortAscending = useAtomValue(sortAscendingAtom)
  const { username } = useTwitterIsBound(account)

  const dispatch = useAppDispatch()
  const userData = useMemo(() => {
    if (!userInfo || !userInfo.data?.user) {
      return {
        refsCount: '0',
        multiplier: '0',
        multiplierStart: '0',
        multiplierEnd: '0',
        refsVolume: '0',
        bonusVolume: '0',
        clearVolume: '0',
        totalVolume: '0',
        refCode: '0',
      }
    }
    return userInfo.data.user
  }, [userInfo])
  const refLink = useMemo(() => {
    return `https://${window.location.host}/trading-competition?ref=${userData.refCode}`
  }, [userData])
  const multiplierData = useMemo(() => {
    return tokensData.reduce((acc: any, cur: any) => {
      acc[cur.id] = cur
      return acc
    }, {})
  }, [tokensData])

  const positionX = (window.screen.width - TWITTER_WIDTH) / 2
  const positionY = (window.screen.height - TWITTER_HEIGHT) / 2
  const shareTweet = useCallback(() => {
    window.open(
      `https://twitter.com/intent/tweet?text=Join the trading competition on XSwap Protocol!%0A%0AParticipate now%3A%20${refLink}%20via%20@XSwapProtocol%0A$xtt $xsp $xdc`,
      'newwindow',
      `left=${positionX}, top=${positionY}, width=${TWITTER_WIDTH}, height=${TWITTER_HEIGHT}`
    )
  }, [refLink])

  const [position, motivation] = useMemo(() => {
    if (topTrades.isLoading) {
      return ['', '']
    }

    if (topTrades.data?.length > 0 && account) {
      const index = topTrades.data.findIndex((v) => v.id.toLowerCase() === account.toLowerCase())
      if (index === -1) {
        return ['', '']
      }
      let desc = ''
      if (index !== 0) {
        desc = `Earn ${formatNumber(
          topTrades.data[0].totalVolume - topTrades.data[index].totalVolume + 1
        )} points and claim #1 place`
      }
      return [`#${index + 1}`, desc]
    }

    return ['#125', 'Trade 123$ more and claim #1 place']
  }, [topTrades])

  /* loading and error state */
  if (userTrades.isLoading) {
    return <LoadingTokenTable rowCount={PAGE_SIZE} />
  } else if (userTrades.error) {
    return (
      <NoTokensState
        message={
          <>
            <AlertTriangle size={16} />
            An error occurred loading your trades. Please try again.
            <p>{userTrades.error.message}</p>
          </>
        }
      />
    )
  }
  // else if (userTrades.data.totalTrade.length === 0) {
  //   return <NoTokensState message={<Trans>You have no trades</Trans>} />
  // }
  else {
    return (
      <>
        <UserInfoContainer>
          <UserInfoWrapper>
            <Row justify="space-between" align="center" gap="sm" width="fit-content">
              <UserPlace>{position}</UserPlace>
              {username && (
                <Telegram
                  href={`https://twitter.com/${username}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >{`@${username}`}</Telegram>
              )}
            </Row>
            <UserDesc>{motivation}</UserDesc>
          </UserInfoWrapper>
          <Row gap="sm" width="auto">
            <InfoDropdown />
            <ButtonOutlined
              style={{
                padding: '9px 20px',
                width: 'auto',
                fontSize: '14px',
                fontWeight: '500',
                borderRadius: '12px',
              }}
              onClick={() => dispatch(updateReferralModal({ isOpen: true, data: { isRules: true } }))}
            >
              Rules
            </ButtonOutlined>

            <TwitterWrapper onClick={shareTweet}>
              Share <ExternalLink strokeWidth="3px" size={13} style={{ marginLeft: '3px' }} />
            </TwitterWrapper>
          </Row>
        </UserInfoContainer>

        <TotalInfoWrapper>
          <InfoBlock
            width="fit-content"
            minWidth="145px"
            firstContent={formatNumber(parseFloat(userData.clearVolume), NumberType.FiatTokenStats)}
            firstLabel="Total Volume"
            description="This is the total pure(one side, divided by 2) trade volume across tracked pools for the connected account during the trading competition."
            bigContent={true}
            hideOnMobile={true}
          />
          <InfoBlock
            width="fit-content"
            minWidth="145px"
            firstContent={parseFloat(userData.totalVolume) === 0 ? '-' : formatNumber(parseFloat(userData.totalVolume))}
            firstLabel="Total Score"
            description="The total score for the connected account is calculated based on the trade volume, inclusive of all bonuses and multipliers, and is utilized in competition ranking."
            bigContent={true}
            hideOnMobile={true}
          />
          <InfoBlock
            firstContent={formatNumber(parseFloat(userData.totalVolume))}
            firstLabel="Total Score"
            secondContent={formatNumber(parseFloat(userData.clearVolume), NumberType.FiatTokenStats)}
            secondLabel="Total Volume"
            //todo
            description="This is the total pure(one side, divided by 2) trade volume across tracked pools for the connected account during the trading competition."
            bigContent={true}
            hideOnDesctop={true}
          />
        </TotalInfoWrapper>

        <InfoBlocksWrapper>
          <InfoBlock
            isFirst={true}
            secondContent={formatNumber(parseFloat(String(userTrades.data?.volume24)), NumberType.FiatTokenStats)}
            secondLabel="24h Volume"
            firstContent={
              parseFloat(userTrades.data?.score24?.toString()) === 0
                ? '-'
                : formatNumber(parseFloat(userTrades.data?.score24?.toString()))
            }
            firstLabel="24h Score"
            description="This displays the 24-hour trade volume and score for the connected account."
          />
          <InfoBlock
            firstContent={`${userData.refsCount == 0 ? 'No' : userData.refsCount} User${
              userData.refsCount > 1 ? 's' : ''
            }`}
            firstLabel="Referred to"
            secondContent={
              <Row justify="space-between">
                <>{`${parseFloat(userData.refsVolume) === 0 ? '-' : formatNumber(parseFloat(userData.refsVolume))}`}</>
                <SmallButtonPurple padding="3px 10px">
                  <CopyText toCopy={refLink}>
                    <span style={{ fontSize: '14px' }}>Ref link</span>
                  </CopyText>
                </SmallButtonPurple>
              </Row>
            }
            secondLabel="Score"
            description="This shows the count of your referees and the total bonus from their trading volume"
          />
          <InfoBlock
            firstContent={
              <Row width="fit-content" gap="0.5rem">
                {userData.multiplier == 0 || userData.multiplierEnd < getNowSeconds() ? (
                  <Content>-</Content>
                ) : (
                  <>
                    <Content>{`${userData.multiplier}%`}</Content>
                    <MultiplierTime>Ends in: 21h</MultiplierTime>{' '}
                  </>
                )}
              </Row>
            }
            firstLabel="Active Multiplier"
            secondContent={`${
              parseFloat(userData.bonusVolume) === 0 ? '-' : formatNumber(parseFloat(userData.bonusVolume))
            }`}
            secondLabel="Bonus"
            description="This displays your active multiplier (if any) and the total bonus earned from all multipliers."
          />
        </InfoBlocksWrapper>

        {userTrades.data.totalTrade.length === 0 ? (
          <NoTokensState message={<Trans>You have no trades</Trans>} />
        ) : (
          <GridContainer id="competition-token-table">
            <HeaderRow />
            <TokenDataContainer>
              {userTrades.data.totalTrade
                .map((v) => ({ ...v, score24: userTrades.data.dayTrade[v.token.id]?.totalUsdVolume ?? 0 }))
                .sort((a, b) =>
                  //@ts-ignore
                  sortableCategories[sortMethod]
                    ? //@ts-ignore
                      Number(a[sortableCategories[sortMethod]]) > Number(b[sortableCategories[sortMethod]])
                      ? sortAscending
                        ? 1
                        : -1
                      : sortAscending
                      ? -1
                      : 1
                    : //@ts-ignore
                    a.totalVolume > b.totalVolume
                    ? 1
                    : -1
                )
                .map(
                  (item, index) =>
                    item?.token.id && (
                      <LoadedRow
                        key={item.token.id}
                        tokenListIndex={index}
                        tokenListLength={userTrades.data.totalTrade.length}
                        totalTrade={item}
                        // sparklineMap={sparklines}
                        //@ts-ignore
                        sortRank={index + 1}
                        multiplierData={multiplierData[item.token.id]}
                      />
                    )
                )}
            </TokenDataContainer>
          </GridContainer>
        )}
      </>
    )
  }
}
